// AUTO-GENERATED by main-frontend/scripts/gen-wb-chrome.mjs — DO NOT EDIT.
// Per-locale website-builder UI-chrome labels (countdown, logout, legal line, consent)
// resolved on the published site by the visitor's content language.

export type WbChrome = {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
  logout: string;
  imprint: string;
  privacy: string;
  reportContent: string;
  cookieAccept: string;
  cookieReject: string;
  cookieDefaultHeader: string;
  cookieDefaultBody: string;
  cookieLearnMore: string;
  loadContentFrom: string;
  consentNote: string;
  cookieSettings: string;
  consentProviders: string;
};

export const WB_CHROME: Record<string, Partial<WbChrome>> = {
  "bg-BG": {
    "days": "Дни",
    "hours": "Часове",
    "minutes": "Минути",
    "seconds": "Секунди",
    "logout": "Изход",
    "imprint": "Импресум",
    "privacy": "Поверителност",
    "reportContent": "Докладване на съдържание",
    "cookieAccept": "Приемам",
    "cookieReject": "Отказвам",
    "cookieDefaultHeader": "Бисквитки и външно съдържание",
    "cookieDefaultBody": "Този сайт използва функционални бисквитки. Видеата и картите идват от външни доставчици и се зареждат едва след твоето съгласие.",
    "cookieLearnMore": "Научи повече",
    "loadContentFrom": "Зареди съдържание от: {provider}",
    "consentNote": "При зареждането твоят IP адрес се изпраща на доставчика.",
    "cookieSettings": "Настройки за бисквитки",
    "consentProviders": "Ако приемеш, се зареждат видеоклипове и карти от YouTube, Vimeo и Google Maps и твоят IP адрес се изпраща до тях."
  },
  "ca-AD": {
    "days": "Days",
    "hours": "Hores",
    "minutes": "Minuts",
    "seconds": "Seconds",
    "logout": "Tanca sessió",
    "imprint": "Avís legal",
    "privacy": "Privadesa",
    "reportContent": "Denuncia contingut",
    "cookieAccept": "Accepta",
    "cookieReject": "Rebutja",
    "cookieDefaultHeader": "Galetes i contingut extern",
    "cookieDefaultBody": "Aquest lloc utilitza galetes funcionals. Els vídeos i els mapes provenen de proveïdors externs i només es carreguen si hi estàs d’acord.",
    "cookieLearnMore": "Més informació",
    "loadContentFrom": "Carrega contingut de: {provider}",
    "consentNote": "En carregar-lo, la teva adreça IP s’envia al proveïdor.",
    "cookieSettings": "Configuració de galetes",
    "consentProviders": "Si acceptes, es carregaran vídeos i mapes de YouTube, Vimeo i Google Maps i la teva adreça IP s’enviarà a aquests serveis."
  },
  "ca-ES": {
    "days": "Days",
    "hours": "Hores",
    "minutes": "Minuts",
    "seconds": "Seconds",
    "logout": "Tanca sessió",
    "imprint": "Avís legal",
    "privacy": "Privadesa",
    "reportContent": "Denuncia contingut",
    "cookieAccept": "Accepta",
    "cookieReject": "Rebutja",
    "cookieDefaultHeader": "Galetes i contingut extern",
    "cookieDefaultBody": "Aquest lloc utilitza galetes funcionals. Els vídeos i els mapes provenen de proveïdors externs i només es carreguen si hi estàs d’acord.",
    "cookieLearnMore": "Més informació",
    "loadContentFrom": "Carrega contingut de: {provider}",
    "consentNote": "En carregar-lo, la teva adreça IP s’envia al proveïdor.",
    "cookieSettings": "Configuració de galetes",
    "consentProviders": "Si acceptes, es carregaran vídeos i mapes de YouTube, Vimeo i Google Maps i la teva adreça IP s’enviarà a aquests serveis."
  },
  "cs-CZ": {
    "days": "Dny",
    "hours": "Hodin",
    "minutes": "Minut",
    "seconds": "Sekundy",
    "logout": "Odhlásit se",
    "imprint": "Tiráž",
    "privacy": "Ochrana osobních údajů",
    "reportContent": "Nahlásit obsah",
    "cookieAccept": "Přijmout",
    "cookieReject": "Odmítnout",
    "cookieDefaultHeader": "Cookies a externí obsah",
    "cookieDefaultBody": "Tento web používá funkční cookies. Videa a mapy pocházejí od externích poskytovatelů a načtou se až po tvém souhlasu.",
    "cookieLearnMore": "Zjistit více",
    "loadContentFrom": "Načíst obsah ze služby {provider}",
    "consentNote": "Při načtení se tvoje IP adresa odešle poskytovateli.",
    "cookieSettings": "Nastavení cookies",
    "consentProviders": "Pokud přijmeš, načtou se videa a mapy ze služeb YouTube, Vimeo a Google Maps a tvoje IP adresa jim bude odeslána."
  },
  "cy-GB": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Hysbysiad cyfreithiol",
    "privacy": "Preifatrwydd",
    "reportContent": "Rhoi gwybod am gynnwys",
    "cookieAccept": "Derbyn",
    "cookieReject": "Gwrthod",
    "cookieDefaultHeader": "Cwcis a chynnwys allanol",
    "cookieDefaultBody": "Mae’r wefan hon yn defnyddio cwcis swyddogaethol. Daw fideos a mapiau gan ddarparwyr allanol a dim ond ar ôl i ti gytuno y byddant yn llwytho.",
    "cookieLearnMore": "Dysgu mwy",
    "loadContentFrom": "Llwytho cynnwys gan: {provider}",
    "consentNote": "Wrth ei lwytho, anfonir dy gyfeiriad IP at y darparwr.",
    "cookieSettings": "Gosodiadau cwcis",
    "consentProviders": "Os byddi di’n derbyn, bydd fideos a mapiau gan YouTube, Vimeo a Google Maps yn cael eu llwytho a bydd dy gyfeiriad IP yn cael ei anfon atynt."
  },
  "da-DK": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Log ud",
    "imprint": "Juridisk information",
    "privacy": "Privatliv",
    "reportContent": "Anmeld indhold",
    "cookieAccept": "Accepter",
    "cookieReject": "Afvis",
    "cookieDefaultHeader": "Cookies og eksternt indhold",
    "cookieDefaultBody": "Denne side bruger funktionelle cookies. Videoer og kort kommer fra eksterne udbydere og indlæses først, når du har givet samtykke.",
    "cookieLearnMore": "Læs mere",
    "loadContentFrom": "Indlæs indhold fra {provider}",
    "consentNote": "Når indholdet indlæses, sendes din IP-adresse til udbyderen.",
    "cookieSettings": "Cookieindstillinger",
    "consentProviders": "Hvis du accepterer, indlæses videoer og kort fra YouTube, Vimeo og Google Maps, og din IP-adresse sendes til dem."
  },
  "de-BE": {
    "days": "Tage",
    "hours": "Stunden",
    "minutes": "Minuten",
    "seconds": "Sekunden",
    "logout": "Abmelden",
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "reportContent": "Inhalt melden",
    "cookieAccept": "Akzeptieren",
    "cookieReject": "Ablehnen",
    "cookieDefaultHeader": "Cookies und externe Inhalte",
    "cookieDefaultBody": "Diese Seite nutzt funktionale Cookies. Videos und Karten stammen von externen Anbietern und werden erst nach deiner Zustimmung geladen.",
    "cookieLearnMore": "Mehr erfahren",
    "loadContentFrom": "Inhalt von {provider} laden",
    "consentNote": "Beim Laden wird deine IP-Adresse an den Anbieter übertragen.",
    "cookieSettings": "Cookie-Einstellungen",
    "consentProviders": "Wenn du akzeptierst, werden Videos und Karten von YouTube, Vimeo und Google Maps geladen und deine IP-Adresse wird an sie übertragen."
  },
  "de-CH": {
    "days": "Tage",
    "hours": "Stunden",
    "minutes": "Minuten",
    "seconds": "Sekunden",
    "logout": "Abmelden",
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "reportContent": "Inhalt melden",
    "cookieAccept": "Akzeptieren",
    "cookieReject": "Ablehnen",
    "cookieDefaultHeader": "Cookies und externe Inhalte",
    "cookieDefaultBody": "Diese Seite nutzt funktionale Cookies. Videos und Karten stammen von externen Anbietern und werden erst nach deiner Zustimmung geladen.",
    "cookieLearnMore": "Mehr erfahren",
    "loadContentFrom": "Inhalt von {provider} laden",
    "consentNote": "Beim Laden wird deine IP-Adresse an den Anbieter übertragen.",
    "cookieSettings": "Cookie-Einstellungen",
    "consentProviders": "Wenn du akzeptierst, werden Videos und Karten von YouTube, Vimeo und Google Maps geladen und deine IP-Adresse wird an sie übertragen."
  },
  "de-DE": {
    "days": "Tage",
    "hours": "Stunden",
    "minutes": "Minuten",
    "seconds": "Sekunden",
    "logout": "Abmelden",
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "reportContent": "Inhalt melden",
    "cookieAccept": "Akzeptieren",
    "cookieReject": "Ablehnen",
    "cookieDefaultHeader": "Cookies und externe Inhalte",
    "cookieDefaultBody": "Diese Seite nutzt funktionale Cookies. Videos und Karten stammen von externen Anbietern und werden erst nach deiner Zustimmung geladen.",
    "cookieLearnMore": "Mehr erfahren",
    "loadContentFrom": "Inhalt von {provider} laden",
    "consentNote": "Beim Laden wird deine IP-Adresse an den Anbieter übertragen.",
    "cookieSettings": "Cookie-Einstellungen",
    "consentProviders": "Wenn du akzeptierst, werden Videos und Karten von YouTube, Vimeo und Google Maps geladen und deine IP-Adresse wird an sie übertragen."
  },
  "de-LI": {
    "days": "Tage",
    "hours": "Stunden",
    "minutes": "Minuten",
    "seconds": "Sekunden",
    "logout": "Abmelden",
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "reportContent": "Inhalt melden",
    "cookieAccept": "Akzeptieren",
    "cookieReject": "Ablehnen",
    "cookieDefaultHeader": "Cookies und externe Inhalte",
    "cookieDefaultBody": "Diese Seite nutzt funktionale Cookies. Videos und Karten stammen von externen Anbietern und werden erst nach deiner Zustimmung geladen.",
    "cookieLearnMore": "Mehr erfahren",
    "loadContentFrom": "Inhalt von {provider} laden",
    "consentNote": "Beim Laden wird deine IP-Adresse an den Anbieter übertragen.",
    "cookieSettings": "Cookie-Einstellungen",
    "consentProviders": "Wenn du akzeptierst, werden Videos und Karten von YouTube, Vimeo und Google Maps geladen und deine IP-Adresse wird an sie übertragen."
  },
  "el-GR": {
    "days": "Ημέρες",
    "hours": "Ώρες",
    "minutes": "Λεπτά",
    "seconds": "Δευτερόλεπτα",
    "logout": "Αποσύνδεση",
    "imprint": "Νομικές πληροφορίες",
    "privacy": "Απόρρητο",
    "reportContent": "Αναφορά περιεχομένου",
    "cookieAccept": "Αποδοχή",
    "cookieReject": "Απόρριψη",
    "cookieDefaultHeader": "Cookies και εξωτερικό περιεχόμενο",
    "cookieDefaultBody": "Αυτός ο ιστότοπος χρησιμοποιεί λειτουργικά cookies. Τα βίντεο και οι χάρτες προέρχονται από εξωτερικούς παρόχους και φορτώνονται μόνο αφού συμφωνήσεις.",
    "cookieLearnMore": "Μάθετε περισσότερα",
    "loadContentFrom": "Φόρτωση περιεχομένου από: {provider}",
    "consentNote": "Κατά τη φόρτωση, η διεύθυνση IP σου αποστέλλεται στον πάροχο.",
    "cookieSettings": "Ρυθμίσεις cookies",
    "consentProviders": "Αν αποδεχτείς, φορτώνονται βίντεο και χάρτες από τα YouTube, Vimeo και Google Maps και η διεύθυνση IP σου αποστέλλεται σε αυτά."
  },
  "en-CA": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Legal notice",
    "privacy": "Privacy",
    "reportContent": "Report content",
    "cookieAccept": "Accept",
    "cookieReject": "Decline",
    "cookieDefaultHeader": "Cookies and external content",
    "cookieDefaultBody": "This site uses functional cookies. Videos and maps come from external providers and only load once you agree.",
    "cookieLearnMore": "Learn more",
    "loadContentFrom": "Load content from {provider}",
    "consentNote": "Loading it sends your IP address to the provider.",
    "cookieSettings": "Cookie settings",
    "consentProviders": "If you accept, videos and maps from YouTube, Vimeo and Google Maps are loaded and your IP address is sent to them."
  },
  "en-GB": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Legal notice",
    "privacy": "Privacy",
    "reportContent": "Report content",
    "cookieAccept": "Accept",
    "cookieReject": "Decline",
    "cookieDefaultHeader": "Cookies and external content",
    "cookieDefaultBody": "This site uses functional cookies. Videos and maps come from external providers and only load once you agree.",
    "cookieLearnMore": "Learn more",
    "loadContentFrom": "Load content from {provider}",
    "consentNote": "Loading it sends your IP address to the provider.",
    "cookieSettings": "Cookie settings",
    "consentProviders": "If you accept, videos and maps from YouTube, Vimeo and Google Maps are loaded and your IP address is sent to them."
  },
  "en-IE": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Legal notice",
    "privacy": "Privacy",
    "reportContent": "Report content",
    "cookieAccept": "Accept",
    "cookieReject": "Decline",
    "cookieDefaultHeader": "Cookies and external content",
    "cookieDefaultBody": "This site uses functional cookies. Videos and maps come from external providers and only load once you agree.",
    "cookieLearnMore": "Learn more",
    "loadContentFrom": "Load content from {provider}",
    "consentNote": "Loading it sends your IP address to the provider.",
    "cookieSettings": "Cookie settings",
    "consentProviders": "If you accept, videos and maps from YouTube, Vimeo and Google Maps are loaded and your IP address is sent to them."
  },
  "en-US": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Legal notice",
    "privacy": "Privacy",
    "reportContent": "Report content",
    "cookieAccept": "Accept",
    "cookieReject": "Decline",
    "cookieDefaultHeader": "Cookies and external content",
    "cookieDefaultBody": "This site uses functional cookies. Videos and maps come from external providers and only load once you agree.",
    "cookieLearnMore": "Learn more",
    "loadContentFrom": "Load content from {provider}",
    "consentNote": "Loading it sends your IP address to the provider.",
    "cookieSettings": "Cookie settings",
    "consentProviders": "If you accept, videos and maps from YouTube, Vimeo and Google Maps are loaded and your IP address is sent to them."
  },
  "es-AR": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Cerrar sesión",
    "imprint": "Aviso legal",
    "privacy": "Privacidad",
    "reportContent": "Denunciar contenido",
    "cookieAccept": "Aceptar",
    "cookieReject": "Rechazar",
    "cookieDefaultHeader": "Cookies y contenido externo",
    "cookieDefaultBody": "Este sitio usa cookies funcionales. Los vídeos y los mapas proceden de proveedores externos y solo se cargan si das tu consentimiento.",
    "cookieLearnMore": "Más información",
    "loadContentFrom": "Cargar contenido de {provider}",
    "consentNote": "Al cargarlo, tu dirección IP se envía al proveedor.",
    "cookieSettings": "Configuración de cookies",
    "consentProviders": "Si aceptas, se cargarán vídeos y mapas de YouTube, Vimeo y Google Maps y tu dirección IP se enviará a estos servicios."
  },
  "es-CL": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Cerrar sesión",
    "imprint": "Aviso legal",
    "privacy": "Privacidad",
    "reportContent": "Denunciar contenido",
    "cookieAccept": "Aceptar",
    "cookieReject": "Rechazar",
    "cookieDefaultHeader": "Cookies y contenido externo",
    "cookieDefaultBody": "Este sitio usa cookies funcionales. Los vídeos y los mapas proceden de proveedores externos y solo se cargan si das tu consentimiento.",
    "cookieLearnMore": "Más información",
    "loadContentFrom": "Cargar contenido de {provider}",
    "consentNote": "Al cargarlo, tu dirección IP se envía al proveedor.",
    "cookieSettings": "Configuración de cookies",
    "consentProviders": "Si aceptas, se cargarán vídeos y mapas de YouTube, Vimeo y Google Maps y tu dirección IP se enviará a estos servicios."
  },
  "es-CO": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Cerrar sesión",
    "imprint": "Aviso legal",
    "privacy": "Privacidad",
    "reportContent": "Denunciar contenido",
    "cookieAccept": "Aceptar",
    "cookieReject": "Rechazar",
    "cookieDefaultHeader": "Cookies y contenido externo",
    "cookieDefaultBody": "Este sitio usa cookies funcionales. Los vídeos y los mapas proceden de proveedores externos y solo se cargan si das tu consentimiento.",
    "cookieLearnMore": "Más información",
    "loadContentFrom": "Cargar contenido de {provider}",
    "consentNote": "Al cargarlo, tu dirección IP se envía al proveedor.",
    "cookieSettings": "Configuración de cookies",
    "consentProviders": "Si aceptas, se cargarán vídeos y mapas de YouTube, Vimeo y Google Maps y tu dirección IP se enviará a estos servicios."
  },
  "es-ES": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Cerrar sesión",
    "imprint": "Aviso legal",
    "privacy": "Privacidad",
    "reportContent": "Denunciar contenido",
    "cookieAccept": "Aceptar",
    "cookieReject": "Rechazar",
    "cookieDefaultHeader": "Cookies y contenido externo",
    "cookieDefaultBody": "Este sitio usa cookies funcionales. Los vídeos y los mapas proceden de proveedores externos y solo se cargan si das tu consentimiento.",
    "cookieLearnMore": "Más información",
    "loadContentFrom": "Cargar contenido de {provider}",
    "consentNote": "Al cargarlo, tu dirección IP se envía al proveedor.",
    "cookieSettings": "Configuración de cookies",
    "consentProviders": "Si aceptas, se cargarán vídeos y mapas de YouTube, Vimeo y Google Maps y tu dirección IP se enviará a estos servicios."
  },
  "es-MX": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Cerrar sesión",
    "imprint": "Aviso legal",
    "privacy": "Privacidad",
    "reportContent": "Denunciar contenido",
    "cookieAccept": "Aceptar",
    "cookieReject": "Rechazar",
    "cookieDefaultHeader": "Cookies y contenido externo",
    "cookieDefaultBody": "Este sitio usa cookies funcionales. Los vídeos y los mapas proceden de proveedores externos y solo se cargan si das tu consentimiento.",
    "cookieLearnMore": "Más información",
    "loadContentFrom": "Cargar contenido de {provider}",
    "consentNote": "Al cargarlo, tu dirección IP se envía al proveedor.",
    "cookieSettings": "Configuración de cookies",
    "consentProviders": "Si aceptas, se cargarán vídeos y mapas de YouTube, Vimeo y Google Maps y tu dirección IP se enviará a estos servicios."
  },
  "es-PE": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Cerrar sesión",
    "imprint": "Aviso legal",
    "privacy": "Privacidad",
    "reportContent": "Denunciar contenido",
    "cookieAccept": "Aceptar",
    "cookieReject": "Rechazar",
    "cookieDefaultHeader": "Cookies y contenido externo",
    "cookieDefaultBody": "Este sitio usa cookies funcionales. Los vídeos y los mapas proceden de proveedores externos y solo se cargan si das tu consentimiento.",
    "cookieLearnMore": "Más información",
    "loadContentFrom": "Cargar contenido de {provider}",
    "consentNote": "Al cargarlo, tu dirección IP se envía al proveedor.",
    "cookieSettings": "Configuración de cookies",
    "consentProviders": "Si aceptas, se cargarán vídeos y mapas de YouTube, Vimeo y Google Maps y tu dirección IP se enviará a estos servicios."
  },
  "es-US": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Cerrar sesión",
    "imprint": "Aviso legal",
    "privacy": "Privacidad",
    "reportContent": "Denunciar contenido",
    "cookieAccept": "Aceptar",
    "cookieReject": "Rechazar",
    "cookieDefaultHeader": "Cookies y contenido externo",
    "cookieDefaultBody": "Este sitio usa cookies funcionales. Los vídeos y los mapas proceden de proveedores externos y solo se cargan si das tu consentimiento.",
    "cookieLearnMore": "Más información",
    "loadContentFrom": "Cargar contenido de {provider}",
    "consentNote": "Al cargarlo, tu dirección IP se envía al proveedor.",
    "cookieSettings": "Configuración de cookies",
    "consentProviders": "Si aceptas, se cargarán vídeos y mapas de YouTube, Vimeo y Google Maps y tu dirección IP se enviará a estos servicios."
  },
  "et-EE": {
    "days": "Päevad",
    "hours": "Tundi",
    "minutes": "Minutit",
    "seconds": "Sekundid",
    "logout": "Logi välja",
    "imprint": "Õiguslik teave",
    "privacy": "Privaatsus",
    "reportContent": "Teata sisust",
    "cookieAccept": "Nõustu",
    "cookieReject": "Keeldu",
    "cookieDefaultHeader": "Küpsised ja väline sisu",
    "cookieDefaultBody": "See leht kasutab funktsionaalseid küpsiseid. Videod ja kaardid pärinevad välistelt teenusepakkujatelt ning laaditakse alles pärast sinu nõusolekut.",
    "cookieLearnMore": "Loe lähemalt",
    "loadContentFrom": "Laadi sisu teenusest: {provider}",
    "consentNote": "Laadimisel edastatakse sinu IP-aadress teenusepakkujale.",
    "cookieSettings": "Küpsiste seaded",
    "consentProviders": "Kui nõustud, laaditakse videod ja kaardid teenustest YouTube, Vimeo ja Google Maps ning sinu IP-aadress edastatakse neile."
  },
  "eu-ES": {
    "days": "Egun",
    "hours": "Ordu",
    "minutes": "Minutu",
    "seconds": "Segundo",
    "logout": "Amaitu saioa",
    "imprint": "Lege oharra",
    "privacy": "Pribatutasuna",
    "reportContent": "Salatu edukia",
    "cookieAccept": "Onartu",
    "cookieReject": "Baztertu",
    "cookieDefaultHeader": "Cookieak eta kanpoko edukia",
    "cookieDefaultBody": "Gune honek cookie funtzionalak erabiltzen ditu. Bideoak eta mapak kanpoko hornitzaileenak dira eta zure baimena eman ondoren bakarrik kargatzen dira.",
    "cookieLearnMore": "Gehiago jakin",
    "loadContentFrom": "Kargatu edukia hemendik: {provider}",
    "consentNote": "Kargatzean, zure IP helbidea hornitzaileari bidaltzen zaio.",
    "cookieSettings": "Cookieen ezarpenak",
    "consentProviders": "Onartzen baduzu, YouTube, Vimeo eta Google Maps zerbitzuetako bideoak eta mapak kargatuko dira eta zure IP helbidea haiei bidaliko zaie."
  },
  "fi-FI": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Kirjaudu ulos",
    "imprint": "Oikeudelliset tiedot",
    "privacy": "Tietosuoja",
    "reportContent": "Ilmoita sisällöstä",
    "cookieAccept": "Hyväksy",
    "cookieReject": "Hylkää",
    "cookieDefaultHeader": "Evästeet ja ulkoinen sisältö",
    "cookieDefaultBody": "Tämä sivusto käyttää toiminnallisia evästeitä. Videot ja kartat tulevat ulkoisilta palveluntarjoajilta ja latautuvat vasta, kun annat suostumuksesi.",
    "cookieLearnMore": "Lue lisää",
    "loadContentFrom": "Lataa sisältö palvelusta: {provider}",
    "consentNote": "Lataaminen lähettää IP-osoitteesi palveluntarjoajalle.",
    "cookieSettings": "Evästeasetukset",
    "consentProviders": "Jos hyväksyt, videot ja kartat ladataan palveluista YouTube, Vimeo ja Google Maps ja IP-osoitteesi lähetetään niille."
  },
  "fr-BE": {
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Minutes",
    "seconds": "Secondes",
    "logout": "Se déconnecter",
    "imprint": "Mentions légales",
    "privacy": "Confidentialité",
    "reportContent": "Signaler un contenu",
    "cookieAccept": "Accepter",
    "cookieReject": "Refuser",
    "cookieDefaultHeader": "Cookies et contenus externes",
    "cookieDefaultBody": "Ce site utilise des cookies fonctionnels. Les vidéos et les cartes proviennent de fournisseurs externes et ne se chargent qu’avec votre accord.",
    "cookieLearnMore": "En savoir plus",
    "loadContentFrom": "Charger le contenu de {provider}",
    "consentNote": "Le chargement transmet votre adresse IP au fournisseur.",
    "cookieSettings": "Paramètres des cookies",
    "consentProviders": "Si vous acceptez, des vidéos et des cartes de YouTube, Vimeo et Google Maps sont chargées et votre adresse IP leur est transmise."
  },
  "fr-CA": {
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Minutes",
    "seconds": "Secondes",
    "logout": "Se déconnecter",
    "imprint": "Mentions légales",
    "privacy": "Confidentialité",
    "reportContent": "Signaler un contenu",
    "cookieAccept": "Accepter",
    "cookieReject": "Refuser",
    "cookieDefaultHeader": "Cookies et contenus externes",
    "cookieDefaultBody": "Ce site utilise des cookies fonctionnels. Les vidéos et les cartes proviennent de fournisseurs externes et ne se chargent qu’avec votre accord.",
    "cookieLearnMore": "En savoir plus",
    "loadContentFrom": "Charger le contenu de {provider}",
    "consentNote": "Le chargement transmet votre adresse IP au fournisseur.",
    "cookieSettings": "Paramètres des cookies",
    "consentProviders": "Si vous acceptez, des vidéos et des cartes de YouTube, Vimeo et Google Maps sont chargées et votre adresse IP leur est transmise."
  },
  "fr-CH": {
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Minutes",
    "seconds": "Secondes",
    "logout": "Se déconnecter",
    "imprint": "Mentions légales",
    "privacy": "Confidentialité",
    "reportContent": "Signaler un contenu",
    "cookieAccept": "Accepter",
    "cookieReject": "Refuser",
    "cookieDefaultHeader": "Cookies et contenus externes",
    "cookieDefaultBody": "Ce site utilise des cookies fonctionnels. Les vidéos et les cartes proviennent de fournisseurs externes et ne se chargent qu’avec votre accord.",
    "cookieLearnMore": "En savoir plus",
    "loadContentFrom": "Charger le contenu de {provider}",
    "consentNote": "Le chargement transmet votre adresse IP au fournisseur.",
    "cookieSettings": "Paramètres des cookies",
    "consentProviders": "Si vous acceptez, des vidéos et des cartes de YouTube, Vimeo et Google Maps sont chargées et votre adresse IP leur est transmise."
  },
  "fr-FR": {
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Minutes",
    "seconds": "Secondes",
    "logout": "Se déconnecter",
    "imprint": "Mentions légales",
    "privacy": "Confidentialité",
    "reportContent": "Signaler un contenu",
    "cookieAccept": "Accepter",
    "cookieReject": "Refuser",
    "cookieDefaultHeader": "Cookies et contenus externes",
    "cookieDefaultBody": "Ce site utilise des cookies fonctionnels. Les vidéos et les cartes proviennent de fournisseurs externes et ne se chargent qu’avec votre accord.",
    "cookieLearnMore": "En savoir plus",
    "loadContentFrom": "Charger le contenu de {provider}",
    "consentNote": "Le chargement transmet votre adresse IP au fournisseur.",
    "cookieSettings": "Paramètres des cookies",
    "consentProviders": "Si vous acceptez, des vidéos et des cartes de YouTube, Vimeo et Google Maps sont chargées et votre adresse IP leur est transmise."
  },
  "fr-MC": {
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Minutes",
    "seconds": "Secondes",
    "logout": "Se déconnecter",
    "imprint": "Mentions légales",
    "privacy": "Confidentialité",
    "reportContent": "Signaler un contenu",
    "cookieAccept": "Accepter",
    "cookieReject": "Refuser",
    "cookieDefaultHeader": "Cookies et contenus externes",
    "cookieDefaultBody": "Ce site utilise des cookies fonctionnels. Les vidéos et les cartes proviennent de fournisseurs externes et ne se chargent qu’avec votre accord.",
    "cookieLearnMore": "En savoir plus",
    "loadContentFrom": "Charger le contenu de {provider}",
    "consentNote": "Le chargement transmet votre adresse IP au fournisseur.",
    "cookieSettings": "Paramètres des cookies",
    "consentProviders": "Si vous acceptez, des vidéos et des cartes de YouTube, Vimeo et Google Maps sont chargées et votre adresse IP leur est transmise."
  },
  "ga-IE": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Fógra dlíthiúil",
    "privacy": "Príobháideacht",
    "reportContent": "Tuairiscigh ábhar",
    "cookieAccept": "Glac",
    "cookieReject": "Diúltaigh",
    "cookieDefaultHeader": "Fianáin agus ábhar seachtrach",
    "cookieDefaultBody": "Úsáideann an suíomh seo fianáin fheidhmiúla. Tagann físeáin agus léarscáileanna ó sholáthraithe seachtracha agus ní lódáiltear iad go dtí go dtugann tú cead.",
    "cookieLearnMore": "Foghlaim tuilleadh",
    "loadContentFrom": "Lódáil ábhar ó: {provider}",
    "consentNote": "Nuair a lódáiltear é, seoltar do sheoladh IP chuig an soláthraí.",
    "cookieSettings": "Socruithe fianán",
    "consentProviders": "Má ghlacann tú leis, lódálfar físeáin agus léarscáileanna ó YouTube, Vimeo agus Google Maps agus seolfar do sheoladh IP chucu."
  },
  "gd-GB": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Fiosrachadh laghail",
    "privacy": "Prìobhaideachd",
    "reportContent": "Aithris susbaint",
    "cookieAccept": "Gabh ris",
    "cookieReject": "Diùlt",
    "cookieDefaultHeader": "Briosgaidean agus susbaint on taobh a-muigh",
    "cookieDefaultBody": "Tha an làrach seo a’ cleachdadh bhriosgaidean gnìomhach. Thig videothan is mapaichean o sholaraichean on taobh a-muigh agus cha luchdaich iad gus an aontaich thu.",
    "cookieLearnMore": "Faigh tuilleadh",
    "loadContentFrom": "Luchdaich susbaint o: {provider}",
    "consentNote": "Nuair a luchdaicheas e, thèid an seòladh IP agad a chur chun an t-solaraiche.",
    "cookieSettings": "Roghainnean bhriosgaidean",
    "consentProviders": "Ma ghabhas tu ris, thèid videothan agus mapaichean o YouTube, Vimeo agus Google Maps a luchdadh agus thèid an seòladh IP agad a chur thuca."
  },
  "gl-ES": {
    "days": "Days",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Seconds",
    "logout": "Pechar sesión",
    "imprint": "Aviso legal",
    "privacy": "Privacidade",
    "reportContent": "Denunciar contido",
    "cookieAccept": "Aceptar",
    "cookieReject": "Rexeitar",
    "cookieDefaultHeader": "Cookies e contido externo",
    "cookieDefaultBody": "Este sitio usa cookies funcionais. Os vídeos e os mapas proceden de provedores externos e só se cargan se dás o teu consentimento.",
    "cookieLearnMore": "Máis información",
    "loadContentFrom": "Cargar contido de {provider}",
    "consentNote": "Ao cargalo, o teu enderezo IP envíase ao provedor.",
    "cookieSettings": "Configuración de cookies",
    "consentProviders": "Se aceptas, cargaranse vídeos e mapas de YouTube, Vimeo e Google Maps e o teu enderezo IP enviarase a estes servizos."
  },
  "hr-HR": {
    "days": "Dani",
    "hours": "Sati",
    "minutes": "Minuta",
    "seconds": "Sekunde",
    "logout": "Odjava",
    "imprint": "Impresum",
    "privacy": "Privatnost",
    "reportContent": "Prijavi sadržaj",
    "cookieAccept": "Prihvati",
    "cookieReject": "Odbij",
    "cookieDefaultHeader": "Kolačići i vanjski sadržaj",
    "cookieDefaultBody": "Ova stranica koristi funkcionalne kolačiće. Videozapisi i karte dolaze od vanjskih pružatelja i učitavaju se tek nakon tvog pristanka.",
    "cookieLearnMore": "Saznaj više",
    "loadContentFrom": "Učitaj sadržaj s usluge {provider}",
    "consentNote": "Učitavanjem se tvoja IP adresa šalje pružatelju usluge.",
    "cookieSettings": "Postavke kolačića",
    "consentProviders": "Ako prihvatiš, učitat će se videozapisi i karte s usluga YouTube, Vimeo i Google Maps, a tvoja IP adresa bit će im poslana."
  },
  "hu-HU": {
    "days": "Napok",
    "hours": "Óra",
    "minutes": "Perc",
    "seconds": "Másodpercek",
    "logout": "Kijelentkezés",
    "imprint": "Impresszum",
    "privacy": "Adatvédelem",
    "reportContent": "Tartalom bejelentése",
    "cookieAccept": "Elfogadom",
    "cookieReject": "Elutasítom",
    "cookieDefaultHeader": "Sütik és külső tartalmak",
    "cookieDefaultBody": "Ez az oldal funkcionális sütiket használ. A videók és térképek külső szolgáltatóktól származnak, és csak a hozzájárulásod után töltődnek be.",
    "cookieLearnMore": "Tudj meg többet",
    "loadContentFrom": "Tartalom betöltése innen: {provider}",
    "consentNote": "Betöltéskor az IP-címed továbbítódik a szolgáltatónak.",
    "cookieSettings": "Sütibeállítások",
    "consentProviders": "Ha elfogadod, a YouTube, a Vimeo és a Google Maps videói és térképei betöltődnek, és az IP-címedet továbbítjuk nekik."
  },
  "is-IS": {
    "days": "Dagar",
    "hours": "Klukkustundir",
    "minutes": "Mínútur",
    "seconds": "Sekúndur",
    "logout": "Skrá út",
    "imprint": "Lagalegar upplýsingar",
    "privacy": "Persónuvernd",
    "reportContent": "Tilkynna efni",
    "cookieAccept": "Samþykkja",
    "cookieReject": "Hafna",
    "cookieDefaultHeader": "Vafrakökur og utanaðkomandi efni",
    "cookieDefaultBody": "Þessi síða notar virknikökur. Myndbönd og kort koma frá utanaðkomandi þjónustuaðilum og hlaðast aðeins eftir að þú samþykkir.",
    "cookieLearnMore": "Læra meira",
    "loadContentFrom": "Hlaða efni frá: {provider}",
    "consentNote": "Við hleðslu er IP-talan þín send til þjónustuaðilans.",
    "cookieSettings": "Kökustillingar",
    "consentProviders": "Ef þú samþykkir verða myndbönd og kort frá YouTube, Vimeo og Google Maps hlaðin og IP-talan þín send til þeirra."
  },
  "it-CH": {
    "days": "Giorni",
    "hours": "Ore",
    "minutes": "Minuti",
    "seconds": "Secondi",
    "logout": "Disconnetti",
    "imprint": "Note legali",
    "privacy": "Privacy",
    "reportContent": "Segnala contenuto",
    "cookieAccept": "Accetta",
    "cookieReject": "Rifiuta",
    "cookieDefaultHeader": "Cookie e contenuti esterni",
    "cookieDefaultBody": "Questo sito usa cookie funzionali. Video e mappe provengono da fornitori esterni e vengono caricati solo con il tuo consenso.",
    "cookieLearnMore": "Scopri di più",
    "loadContentFrom": "Carica il contenuto da {provider}",
    "consentNote": "Caricandolo, il tuo indirizzo IP viene inviato al fornitore.",
    "cookieSettings": "Impostazioni cookie",
    "consentProviders": "Se accetti, vengono caricati video e mappe di YouTube, Vimeo e Google Maps e il tuo indirizzo IP viene trasmesso a questi servizi."
  },
  "it-IT": {
    "days": "Giorni",
    "hours": "Ore",
    "minutes": "Minuti",
    "seconds": "Secondi",
    "logout": "Disconnetti",
    "imprint": "Note legali",
    "privacy": "Privacy",
    "reportContent": "Segnala contenuto",
    "cookieAccept": "Accetta",
    "cookieReject": "Rifiuta",
    "cookieDefaultHeader": "Cookie e contenuti esterni",
    "cookieDefaultBody": "Questo sito usa cookie funzionali. Video e mappe provengono da fornitori esterni e vengono caricati solo con il tuo consenso.",
    "cookieLearnMore": "Scopri di più",
    "loadContentFrom": "Carica il contenuto da {provider}",
    "consentNote": "Caricandolo, il tuo indirizzo IP viene inviato al fornitore.",
    "cookieSettings": "Impostazioni cookie",
    "consentProviders": "Se accetti, vengono caricati video e mappe di YouTube, Vimeo e Google Maps e il tuo indirizzo IP viene trasmesso a questi servizi."
  },
  "it-SM": {
    "days": "Giorni",
    "hours": "Ore",
    "minutes": "Minuti",
    "seconds": "Secondi",
    "logout": "Disconnetti",
    "imprint": "Note legali",
    "privacy": "Privacy",
    "reportContent": "Segnala contenuto",
    "cookieAccept": "Accetta",
    "cookieReject": "Rifiuta",
    "cookieDefaultHeader": "Cookie e contenuti esterni",
    "cookieDefaultBody": "Questo sito usa cookie funzionali. Video e mappe provengono da fornitori esterni e vengono caricati solo con il tuo consenso.",
    "cookieLearnMore": "Scopri di più",
    "loadContentFrom": "Carica il contenuto da {provider}",
    "consentNote": "Caricandolo, il tuo indirizzo IP viene inviato al fornitore.",
    "cookieSettings": "Impostazioni cookie",
    "consentProviders": "Se accetti, vengono caricati video e mappe di YouTube, Vimeo e Google Maps e il tuo indirizzo IP viene trasmesso a questi servizi."
  },
  "it-VA": {
    "days": "Giorni",
    "hours": "Ore",
    "minutes": "Minuti",
    "seconds": "Secondi",
    "logout": "Disconnetti",
    "imprint": "Note legali",
    "privacy": "Privacy",
    "reportContent": "Segnala contenuto",
    "cookieAccept": "Accetta",
    "cookieReject": "Rifiuta",
    "cookieDefaultHeader": "Cookie e contenuti esterni",
    "cookieDefaultBody": "Questo sito usa cookie funzionali. Video e mappe provengono da fornitori esterni e vengono caricati solo con il tuo consenso.",
    "cookieLearnMore": "Scopri di più",
    "loadContentFrom": "Carica il contenuto da {provider}",
    "consentNote": "Caricandolo, il tuo indirizzo IP viene inviato al fornitore.",
    "cookieSettings": "Impostazioni cookie",
    "consentProviders": "Se accetti, vengono caricati video e mappe di YouTube, Vimeo e Google Maps e il tuo indirizzo IP viene trasmesso a questi servizi."
  },
  "lb-LU": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Impressum",
    "privacy": "Dateschutz",
    "reportContent": "Inhalt mellen",
    "cookieAccept": "Akzeptéieren",
    "cookieReject": "Refuséieren",
    "cookieDefaultHeader": "Cookien an extern Inhalter",
    "cookieDefaultBody": "Dës Säit benotzt funktional Cookien. Videoen a Kaarte kommen vun externen Ubidder a ginn eréischt no denger Zoustëmmung gelueden.",
    "cookieLearnMore": "Méi gewuer ginn",
    "loadContentFrom": "Inhalt lueden vun: {provider}",
    "consentNote": "Beim Luede gëtt deng IP-Adress un den Ubidder iwwerdroen.",
    "cookieSettings": "Cookie-Astellungen",
    "consentProviders": "Wann s du akzeptéiers, gi Videoen a Kaarte vu YouTube, Vimeo a Google Maps gelueden an deng IP-Adress gëtt un si iwwerdroen."
  },
  "lt-LT": {
    "days": "Dienos",
    "hours": "Valandos",
    "minutes": "Minutės",
    "seconds": "Sekundės",
    "logout": "Atsijungti",
    "imprint": "Teisinė informacija",
    "privacy": "Privatumas",
    "reportContent": "Pranešti apie turinį",
    "cookieAccept": "Sutinku",
    "cookieReject": "Nesutinku",
    "cookieDefaultHeader": "Slapukai ir išorinis turinys",
    "cookieDefaultBody": "Ši svetainė naudoja funkcinius slapukus. Vaizdo įrašai ir žemėlapiai teikiami išorinių paslaugų teikėjų ir įkeliami tik gavus tavo sutikimą.",
    "cookieLearnMore": "Sužinoti daugiau",
    "loadContentFrom": "Įkelti turinį iš: {provider}",
    "consentNote": "Įkeliant tavo IP adresas perduodamas paslaugos teikėjui.",
    "cookieSettings": "Slapukų nustatymai",
    "consentProviders": "Jei sutiksi, bus įkelti vaizdo įrašai ir žemėlapiai iš YouTube, Vimeo ir Google Maps, o tavo IP adresas bus perduotas šioms paslaugoms."
  },
  "lv-LV": {
    "days": "Dienas",
    "hours": "Stundas",
    "minutes": "Minūtes",
    "seconds": "Sekundes",
    "logout": "Izrakstīties",
    "imprint": "Juridiskā informācija",
    "privacy": "Privātums",
    "reportContent": "Ziņot par saturu",
    "cookieAccept": "Piekrist",
    "cookieReject": "Noraidīt",
    "cookieDefaultHeader": "Sīkdatnes un ārējs saturs",
    "cookieDefaultBody": "Šī vietne izmanto funkcionālās sīkdatnes. Video un kartes nāk no ārējiem pakalpojumu sniedzējiem un tiek ielādēti tikai pēc tavas piekrišanas.",
    "cookieLearnMore": "Uzzināt vairāk",
    "loadContentFrom": "Ielādēt saturu no: {provider}",
    "consentNote": "Ielādējot tava IP adrese tiek nosūtīta pakalpojuma sniedzējam.",
    "cookieSettings": "Sīkdatņu iestatījumi",
    "consentProviders": "Ja piekritīsi, tiks ielādēti video un kartes no YouTube, Vimeo un Google Maps, un tava IP adrese tiks nosūtīta šiem pakalpojumiem."
  },
  "mt-MT": {
    "days": "Days",
    "hours": "Sigħat",
    "minutes": "Minuti",
    "seconds": "Seconds",
    "logout": "Oħroġ",
    "imprint": "Avviż legali",
    "privacy": "Privatezza",
    "reportContent": "Irrapporta kontenut",
    "cookieAccept": "Aċċetta",
    "cookieReject": "Irrifjuta",
    "cookieDefaultHeader": "Cookies u kontenut estern",
    "cookieDefaultBody": "Dan is-sit juża cookies funzjonali. Il-vidjows u l-mapep jiġu minn fornituri esterni u jitgħabbew biss wara li taqbel.",
    "cookieLearnMore": "Itgħallem aktar",
    "loadContentFrom": "Għabbi l-kontenut minn: {provider}",
    "consentNote": "Meta jitgħabba, l-indirizz IP tiegħek jintbagħat lill-fornitur.",
    "cookieSettings": "Issettjar tal-cookies",
    "consentProviders": "Jekk taċċetta, jitgħabbew vidjows u mapep minn YouTube, Vimeo u Google Maps u l-indirizz IP tiegħek jintbagħat lilhom."
  },
  "nb-NO": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logg ut",
    "imprint": "Juridisk informasjon",
    "privacy": "Personvern",
    "reportContent": "Rapporter innhold",
    "cookieAccept": "Godta",
    "cookieReject": "Avslå",
    "cookieDefaultHeader": "Informasjonskapsler og eksternt innhold",
    "cookieDefaultBody": "Denne siden bruker funksjonelle informasjonskapsler. Videoer og kart kommer fra eksterne leverandører og lastes først inn når du har samtykket.",
    "cookieLearnMore": "Les mer",
    "loadContentFrom": "Last inn innhold fra {provider}",
    "consentNote": "Når innholdet lastes inn, sendes IP-adressen din til leverandøren.",
    "cookieSettings": "Innstillinger for informasjonskapsler",
    "consentProviders": "Hvis du godtar, lastes videoer og kart fra YouTube, Vimeo og Google Maps inn, og IP-adressen din sendes til dem."
  },
  "nl-BE": {
    "days": "Dagen",
    "hours": "Uren",
    "minutes": "Minuten",
    "seconds": "Seconden",
    "logout": "Uitloggen",
    "imprint": "Juridische informatie",
    "privacy": "Privacy",
    "reportContent": "Inhoud melden",
    "cookieAccept": "Accepteren",
    "cookieReject": "Weigeren",
    "cookieDefaultHeader": "Cookies en externe inhoud",
    "cookieDefaultBody": "Deze site gebruikt functionele cookies. Video’s en kaarten komen van externe aanbieders en worden pas geladen nadat je toestemming hebt gegeven.",
    "cookieLearnMore": "Meer informatie",
    "loadContentFrom": "Inhoud van {provider} laden",
    "consentNote": "Bij het laden wordt je IP-adres naar de aanbieder gestuurd.",
    "cookieSettings": "Cookie-instellingen",
    "consentProviders": "Als je accepteert, worden video’s en kaarten van YouTube, Vimeo en Google Maps geladen en wordt je IP-adres naar hen verzonden."
  },
  "nl-NL": {
    "days": "Dagen",
    "hours": "Uren",
    "minutes": "Minuten",
    "seconds": "Seconden",
    "logout": "Uitloggen",
    "imprint": "Juridische informatie",
    "privacy": "Privacy",
    "reportContent": "Inhoud melden",
    "cookieAccept": "Accepteren",
    "cookieReject": "Weigeren",
    "cookieDefaultHeader": "Cookies en externe inhoud",
    "cookieDefaultBody": "Deze site gebruikt functionele cookies. Video’s en kaarten komen van externe aanbieders en worden pas geladen nadat je toestemming hebt gegeven.",
    "cookieLearnMore": "Meer informatie",
    "loadContentFrom": "Inhoud van {provider} laden",
    "consentNote": "Bij het laden wordt je IP-adres naar de aanbieder gestuurd.",
    "cookieSettings": "Cookie-instellingen",
    "consentProviders": "Als je accepteert, worden video’s en kaarten van YouTube, Vimeo en Google Maps geladen en wordt je IP-adres naar hen verzonden."
  },
  "pl-PL": {
    "days": "Dni",
    "hours": "Godziny",
    "minutes": "Minuty",
    "seconds": "Sekundy",
    "logout": "Wyloguj się",
    "imprint": "Nota prawna",
    "privacy": "Prywatność",
    "reportContent": "Zgłoś treść",
    "cookieAccept": "Akceptuję",
    "cookieReject": "Odrzucam",
    "cookieDefaultHeader": "Pliki cookie i treści zewnętrzne",
    "cookieDefaultBody": "Ta strona używa funkcjonalnych plików cookie. Filmy i mapy pochodzą od zewnętrznych dostawców i są wczytywane dopiero po wyrażeniu zgody.",
    "cookieLearnMore": "Dowiedz się więcej",
    "loadContentFrom": "Wczytaj treść z serwisu {provider}",
    "consentNote": "Wczytanie powoduje przesłanie adresu IP do dostawcy.",
    "cookieSettings": "Ustawienia plików cookie",
    "consentProviders": "Po zaakceptowaniu zostaną załadowane filmy i mapy z serwisów YouTube, Vimeo i Google Maps, a adres IP zostanie im przekazany."
  },
  "pt-BR": {
    "days": "Dias",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Terminar sessão",
    "imprint": "Aviso legal",
    "privacy": "Privacidade",
    "reportContent": "Denunciar conteúdo",
    "cookieAccept": "Aceitar",
    "cookieReject": "Recusar",
    "cookieDefaultHeader": "Cookies e conteúdo externo",
    "cookieDefaultBody": "Este site usa cookies funcionais. Vídeos e mapas vêm de provedores externos e só são carregados depois que você concordar.",
    "cookieLearnMore": "Saber mais",
    "loadContentFrom": "Carregar conteúdo de {provider}",
    "consentNote": "Ao carregar, seu endereço IP é enviado ao provedor.",
    "cookieSettings": "Configurações de cookies",
    "consentProviders": "Se você aceitar, vídeos e mapas do YouTube, Vimeo e Google Maps serão carregados e seu endereço IP será enviado a esses serviços."
  },
  "pt-PT": {
    "days": "Dias",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "logout": "Terminar sessão",
    "imprint": "Aviso legal",
    "privacy": "Privacidade",
    "reportContent": "Denunciar conteúdo",
    "cookieAccept": "Aceitar",
    "cookieReject": "Recusar",
    "cookieDefaultHeader": "Cookies e conteúdos externos",
    "cookieDefaultBody": "Este site utiliza cookies funcionais. Os vídeos e os mapas provêm de fornecedores externos e só são carregados depois de dares o teu consentimento.",
    "cookieLearnMore": "Saber mais",
    "loadContentFrom": "Carregar conteúdo de {provider}",
    "consentNote": "Ao carregar, o teu endereço IP é enviado ao fornecedor.",
    "cookieSettings": "Definições de cookies",
    "consentProviders": "Se aceitares, são carregados vídeos e mapas do YouTube, Vimeo e Google Maps e o teu endereço IP é enviado a estes serviços."
  },
  "rm-CH": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logout",
    "imprint": "Impressum",
    "privacy": "Protecziun da datas",
    "reportContent": "Annunziar cuntegn",
    "cookieAccept": "Acceptar",
    "cookieReject": "Refusar",
    "cookieDefaultHeader": "Cookies e cuntegns externs",
    "cookieDefaultBody": "Questa pagina utilisescha cookies funcziunals. Videos e chartas derivan da purschiders externs e vegnan chargiads pir suenter tes consentiment.",
    "cookieLearnMore": "Ulteriuras infurmaziuns",
    "loadContentFrom": "Chargiar cuntegn da: {provider}",
    "consentNote": "Cun chargiar vegn tia adressa IP transmessa al purschider.",
    "cookieSettings": "Parameters da cookies",
    "consentProviders": "Sche ti acceptas, vegnan chargiads videos e chartas da YouTube, Vimeo e Google Maps e tia adressa IP vegn transmessa a quests servetschs."
  },
  "ro-RO": {
    "days": "Zile",
    "hours": "Ore",
    "minutes": "Minute",
    "seconds": "Secunde",
    "logout": "Deconectare",
    "imprint": "Informații legale",
    "privacy": "Confidențialitate",
    "reportContent": "Raportează conținut",
    "cookieAccept": "Acceptă",
    "cookieReject": "Refuză",
    "cookieDefaultHeader": "Cookie-uri și conținut extern",
    "cookieDefaultBody": "Acest site folosește cookie-uri funcționale. Videoclipurile și hărțile provin de la furnizori externi și se încarcă doar după ce îți dai acordul.",
    "cookieLearnMore": "Află mai multe",
    "loadContentFrom": "Încarcă conținut de la {provider}",
    "consentNote": "La încărcare, adresa ta IP este trimisă furnizorului.",
    "cookieSettings": "Setări cookie-uri",
    "consentProviders": "Dacă accepți, se încarcă videoclipuri și hărți de la YouTube, Vimeo și Google Maps, iar adresa ta IP le este transmisă."
  },
  "sk-SK": {
    "days": "Dni",
    "hours": "Hodiny",
    "minutes": "Minúty",
    "seconds": "Sekundy",
    "logout": "Odhlásiť sa",
    "imprint": "Tiráž",
    "privacy": "Ochrana údajov",
    "reportContent": "Nahlásiť obsah",
    "cookieAccept": "Prijať",
    "cookieReject": "Odmietnuť",
    "cookieDefaultHeader": "Cookies a externý obsah",
    "cookieDefaultBody": "Táto stránka používa funkčné cookies. Videá a mapy pochádzajú od externých poskytovateľov a načítajú sa až po tvojom súhlase.",
    "cookieLearnMore": "Dozvedieť sa viac",
    "loadContentFrom": "Načítať obsah zo služby {provider}",
    "consentNote": "Pri načítaní sa tvoja IP adresa odošle poskytovateľovi.",
    "cookieSettings": "Nastavenia cookies",
    "consentProviders": "Ak prijmeš, načítajú sa videá a mapy zo služieb YouTube, Vimeo a Google Maps a tvoja IP adresa im bude odoslaná."
  },
  "sl-SI": {
    "days": "Dnevi",
    "hours": "Ur",
    "minutes": "Minut",
    "seconds": "Sekunde",
    "logout": "Odjava",
    "imprint": "Kolofon",
    "privacy": "Zasebnost",
    "reportContent": "Prijavi vsebino",
    "cookieAccept": "Sprejmi",
    "cookieReject": "Zavrni",
    "cookieDefaultHeader": "Piškotki in zunanja vsebina",
    "cookieDefaultBody": "Ta stran uporablja funkcionalne piškotke. Videoposnetki in zemljevidi prihajajo od zunanjih ponudnikov in se naložijo šele po tvoji privolitvi.",
    "cookieLearnMore": "Več o tem",
    "loadContentFrom": "Naloži vsebino iz storitve {provider}",
    "consentNote": "Ob nalaganju se tvoj naslov IP pošlje ponudniku.",
    "cookieSettings": "Nastavitve piškotkov",
    "consentProviders": "Če sprejmeš, se naložijo videoposnetki in zemljevidi storitev YouTube, Vimeo in Google Maps, tvoj naslov IP pa se jim posreduje."
  },
  "sq-AL": {
    "days": "Ditë",
    "hours": "Orë",
    "minutes": "Minuta",
    "seconds": "Sekonda",
    "logout": "Dilni",
    "imprint": "Njoftim ligjor",
    "privacy": "Privatësia",
    "reportContent": "Raporto përmbajtje",
    "cookieAccept": "Prano",
    "cookieReject": "Refuzo",
    "cookieDefaultHeader": "Cookies dhe përmbajtje e jashtme",
    "cookieDefaultBody": "Kjo faqe përdor cookies funksionale. Videot dhe hartat vijnë nga ofrues të jashtëm dhe ngarkohen vetëm pasi të japësh pëlqimin.",
    "cookieLearnMore": "Mëso më shumë",
    "loadContentFrom": "Ngarko përmbajtjen nga: {provider}",
    "consentNote": "Gjatë ngarkimit, adresa jote IP i dërgohet ofruesit.",
    "cookieSettings": "Cilësimet e cookies",
    "consentProviders": "Nëse pranon, ngarkohen video dhe harta nga YouTube, Vimeo dhe Google Maps dhe adresa jote IP u dërgohet atyre."
  },
  "sr-RS": {
    "days": "Dani",
    "hours": "Sati",
    "minutes": "Minuta",
    "seconds": "Sekunde",
    "logout": "Odjava",
    "imprint": "Impresum",
    "privacy": "Privatnost",
    "reportContent": "Prijavi sadržaj",
    "cookieAccept": "Prihvati",
    "cookieReject": "Odbij",
    "cookieDefaultHeader": "Kolačići i spoljni sadržaj",
    "cookieDefaultBody": "Ovaj sajt koristi funkcionalne kolačiće. Video-snimci i mape dolaze od spoljnih pružalaca usluga i učitavaju se tek nakon tvoje saglasnosti.",
    "cookieLearnMore": "Saznaj više",
    "loadContentFrom": "Učitaj sadržaj sa servisa {provider}",
    "consentNote": "Pri učitavanju se tvoja IP adresa šalje pružaocu usluge.",
    "cookieSettings": "Podešavanja kolačića",
    "consentProviders": "Ako prihvatiš, učitaće se video-snimci i mape sa servisa YouTube, Vimeo i Google Maps, a tvoja IP adresa biće im poslata."
  },
  "sv-SE": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "logout": "Logga ut",
    "imprint": "Juridisk information",
    "privacy": "Integritet",
    "reportContent": "Anmäl innehåll",
    "cookieAccept": "Godkänn",
    "cookieReject": "Avböj",
    "cookieDefaultHeader": "Cookies och externt innehåll",
    "cookieDefaultBody": "Den här sidan använder funktionella cookies. Videor och kartor kommer från externa leverantörer och laddas först när du har samtyckt.",
    "cookieLearnMore": "Läs mer",
    "loadContentFrom": "Ladda innehåll från {provider}",
    "consentNote": "När innehållet laddas skickas din IP-adress till leverantören.",
    "cookieSettings": "Cookie-inställningar",
    "consentProviders": "Om du godkänner laddas videor och kartor från YouTube, Vimeo och Google Maps och din IP-adress skickas till dem."
  }
};
